document.addEventListener('DOMContentLoaded', () => {
    
    // Ensure GSAP and ScrollTrigger are loaded
    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
        gsap.registerPlugin(ScrollTrigger);

        // Cleaned up old bottleSection

        // Hero Section Animations
        const heroSection = document.getElementById('hero-section');
        const heroMedia = document.querySelector('.gsap-hero-media');
        const heroBg = document.querySelector('.gsap-hero-bg');
        const heroProduct = document.querySelector('.gsap-hero-product');
        const heroFades = document.querySelectorAll('.gsap-hero-fade');

        // 1. Initial Load Animations (coordinated to not clash)
        const heroTl = gsap.timeline();
        
        // Prevent FOUC: Elements are hidden in CSS, make them visible for GSAP to animate them
        if (heroMedia) gsap.set(heroMedia, { visibility: 'visible' });
        if (heroBg) gsap.set(heroBg, { visibility: 'visible' });
        if (heroProduct) gsap.set(heroProduct, { visibility: 'visible' });
        if (heroFades.length > 0) gsap.set(heroFades, { visibility: 'visible' });

        if (heroMedia) {
            heroTl.from(heroMedia, {
                opacity: 0,
                duration: 2.5,
                ease: "power2.inOut"
            }, 0);
        }

        if (heroBg) {
            heroTl.from(heroBg, {
                scale: 1.1,
                opacity: 0,
                duration: 1.5,
                ease: "power2.out"
            }, 0.5); // Starts slightly after the video begins fading in
        }
        
        if (heroProduct) {
            heroTl.from(heroProduct, {
                y: 50,
                opacity: 0,
                duration: 1.5,
                ease: "power3.out"
            }, 1.5); // Starts after logo
        }

        if (heroFades.length > 0) {
            heroTl.from(heroFades, {
                y: 30,
                opacity: 0,
                duration: 1,
                stagger: 0.2,
                ease: "power2.out"
            }, 2.0); // Starts after bottle
        }

        // 2. Global Section Fade-Out (Only apply to Hero Section)
        
        // Hide header logic
        const navHeader = document.getElementById('adamea-header');
        const rollingBottleSection = document.getElementById('bottle-scroll-section');
        
        if (navHeader) {
            if (heroSection && rollingBottleSection) {
                // Homepage: Hide only when reaching Rolling Bottle section
                gsap.to(navHeader, {
                    scrollTrigger: {
                        trigger: rollingBottleSection,
                        start: "top top",
                        end: "bottom top",
                        scrub: true
                    },
                    yPercent: -100,
                    opacity: 0,
                    ease: "none"
                });
            } else {
                // Product Page / Other Pages: Fast scroll-down hide
                let lastScroll = 0;
                window.addEventListener('scroll', () => {
                    const currentScroll = window.pageYOffset;
                    if (currentScroll > 100 && currentScroll > lastScroll) {
                        gsap.to(navHeader, { yPercent: -100, opacity: 0, duration: 0.3, ease: "power2.out", overwrite: true });
                    } else {
                        gsap.to(navHeader, { yPercent: 0, opacity: 1, duration: 0.3, ease: "power2.out", overwrite: true });
                    }
                    lastScroll = currentScroll <= 0 ? 0 : currentScroll;
                });
            }
        }
        
        if (heroSection) {
            const heroWrapper = heroSection.closest('.shopify-section') || heroSection;
            gsap.to(heroWrapper, {
                scrollTrigger: {
                    trigger: heroWrapper,
                    start: "top top", 
                    end: "bottom top", 
                    scrub: true
                },
                opacity: 0,
                y: -100, 
                ease: "none"
            });
        }

        // Removed Fade IN the header logo



        // 3. Marquee Animation (Handled via CSS now for better mobile performance)

        // 3.5 Magnetic / Parallax Effect for Hero Bottle (Desktop Only)
        if (heroProduct && window.matchMedia("(min-width: 768px)").matches) {
            heroSection.addEventListener("mousemove", (e) => {
                const { clientX, clientY } = e;
                const { left, top, width, height } = heroSection.getBoundingClientRect();
                
                // Calculate percentage from center of the screen
                const xPos = (clientX - left - width / 2) / (width / 2);
                const yPos = (clientY - top - height / 2) / (height / 2);

                gsap.to(heroProduct, {
                    x: xPos * 30, // Max move 30px
                    y: yPos * 30, 
                    rotationY: xPos * 10,
                    rotationX: -yPos * 10,
                    ease: "power2.out",
                    duration: 1
                });
            });

            heroSection.addEventListener("mouseleave", () => {
                gsap.to(heroProduct, {
                    x: 0,
                    y: 0,
                    rotationY: 0,
                    rotationX: 0,
                    ease: "power3.out",
                    duration: 1.5
                });
            });
        }

        // 3.6 Gyroscope / Parallax Effect for Hero Bottle (Mobile Only)
        if (heroProduct && window.innerWidth < 768) {
            let initialBeta = null;
            let initialGamma = null;
            let gyroActive = false;
            
            const startGyro = () => {
                if (gyroActive) return;
                gyroActive = true;
                
                window.addEventListener('deviceorientation', (e) => {
                    let gamma = e.gamma; // left-to-right tilt
                    let beta = e.beta;   // front-to-back tilt

                    if (gamma === null || beta === null) return;
                    
                    if (initialBeta === null) {
                        initialBeta = beta;
                        initialGamma = gamma;
                    }

                    let diffGamma = gamma - initialGamma;
                    let diffBeta = beta - initialBeta;

                    if (diffGamma > 30) diffGamma = 30;
                    if (diffGamma < -30) diffGamma = -30;
                    if (diffBeta > 30) diffBeta = 30;
                    if (diffBeta < -30) diffBeta = -30;

                    const xPos = diffGamma / 30;
                    const yPos = diffBeta / 30;

                    gsap.to(heroProduct, {
                        x: xPos * 25,
                        y: yPos * 25,
                        rotationY: xPos * 15,
                        rotationX: -yPos * 15,
                        transformPerspective: 1000,
                        ease: "power2.out",
                        duration: 0.3
                    });
                });
            };

            const requestGyroPermission = () => {
                if (typeof DeviceOrientationEvent !== 'undefined' && typeof DeviceOrientationEvent.requestPermission === 'function') {
                    DeviceOrientationEvent.requestPermission()
                        .then(permissionState => {
                            if (permissionState === 'granted') {
                                startGyro();
                            }
                        })
                        .catch(console.error);
                } else {
                    startGyro();
                }
                document.body.removeEventListener('click', requestGyroPermission);
                document.body.removeEventListener('touchstart', requestGyroPermission);
            };

            // If it's modern iOS, wait for any click on the screen to request permission. 
            // If it's Android, just start immediately.
            if (typeof DeviceOrientationEvent !== 'undefined' && typeof DeviceOrientationEvent.requestPermission === 'function') {
                document.body.addEventListener('click', requestGyroPermission, { once: true });
                document.body.addEventListener('touchstart', requestGyroPermission, { once: true });
            } else {
                startGyro();
            }
        }

        // 4. Collection Reveal Scroll Logic
        const bottleSection = document.getElementById('bottle-scroll-section');
        if (bottleSection) {
            let mm = gsap.matchMedia();
            
            mm.add({
                isMobile: "(max-width: 767px)",
                isDesktop: "(min-width: 768px)"
            }, (context) => {
                let { isMobile } = context.conditions;
                
                const dodgeDown = isMobile ? "10vh" : "0px";
                const dodgeUp = isMobile ? "-10vh" : "0px";

                const tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: bottleSection,
                        start: "top top",
                        end: "bottom bottom",
                        scrub: 1,
                    }
                });

                // Info 1 (Premium) and List 1 fade in, then fade out
                tl.to(["#info-1", "#list-1"], { opacity: 1, y: 0, duration: 0.5 }, 0.2)
                  .to(["#info-1", "#list-1"], { opacity: 0, y: -20, duration: 0.5 }, 1.5);
                  
                // Memory Atlas bottle moves DOWN to dodge top card
                tl.to("#scrolling-bottle-1", { y: dodgeDown, duration: 1.0, ease: "power2.inOut" }, 0.2);
                
                // Initialize Bottle 2 to exactly match Bottle 1's position before it even fades in
                tl.set("#scrolling-bottle-2", { y: dodgeDown }, 0);

                // Smooth Crossfade: Bottle 1 fades out, Bottle 2 fades in simultaneously
                tl.to("#scrolling-bottle-1", {
                    opacity: 0,
                    duration: 1.0,
                    ease: "power2.inOut"
                }, 1.2);
                
                tl.to("#scrolling-bottle-2", {
                    opacity: 1,
                    duration: 1.0,
                    ease: "power2.inOut"
                }, 1.2);

                // Background Text Transition (Memory Atlas -> Everyday Edit)
                tl.to("#bg-text-1", { opacity: 0, y: -50, duration: 0.8, ease: "power2.inOut" }, 1.2);
                tl.to("#bg-text-2", { opacity: 1, y: 0, duration: 0.8, ease: "power2.inOut" }, 1.4);

                // Info 2 (Everyday Edit) and List 2 fade in
                tl.to(["#info-2", "#list-2"], { opacity: 1, y: 0, duration: 0.8, ease: "power2.out" }, 2.0);
                
                // Everyday Edit bottle moves UP smoothly to dodge bottom card
                tl.to("#scrolling-bottle-2", { y: dodgeUp, duration: 1.2, ease: "power2.inOut" }, 1.8);
                
                return () => {
                    tl.kill(); // Ensure it completely resets on breakpoint changes
                    gsap.set(["#scrolling-bottle-1", "#scrolling-bottle-2"], { clearProps: "y" });
                };
            });
        }

        // 5. Global Scroll Fade Up
        const fadeUpElements = document.querySelectorAll('.gsap-fade-up');
        fadeUpElements.forEach(el => {
            gsap.fromTo(el, 
                { opacity: 0, y: 30 },
                { 
                    opacity: 1, 
                    y: 0, 
                    duration: 1, 
                    ease: "power2.out",
                    scrollTrigger: {
                        trigger: el,
                        start: "top 85%", // Triggers when the top of the element hits 85% down the viewport
                    }
                }
            );
        });

        // 6. Mood Carousel & Category Tab Switcher Logic
        const tabBtns = document.querySelectorAll('.mood-tab-btn');
        const tabContents = document.querySelectorAll('.mood-tab-content');

        // Function to initialize an individual carousel track within a tab panel
        function setupCarousel(panel) {
            const track = panel.querySelector('.adamea-carousel-track');
            if (!track) return null;
            
            const items = panel.querySelectorAll('.adamea-carousel-item');
            if (items.length === 0) return null;

            const prevBtn = panel.querySelector('.adamea-carousel-prev');
            const nextBtn = panel.querySelector('.adamea-carousel-next');
            const dotsContainer = panel.querySelector('.adamea-carousel-dots');
            
            // Clear and create dots
            if (dotsContainer) {
                dotsContainer.innerHTML = '';
                items.forEach((_, i) => {
                    const dot = document.createElement('div');
                    dot.classList.add('w-2', 'h-2', 'rounded-full', 'bg-white/20', 'transition-all', 'duration-300', 'cursor-pointer');
                    if (i === 0) dot.classList.replace('bg-white/20', 'bg-white');
                    dotsContainer.appendChild(dot);
                    
                    dot.addEventListener('click', () => {
                        const targetLeft = items[i].offsetLeft - (track.clientWidth / 2) + (items[i].clientWidth / 2);
                        track.scrollTo({
                            left: targetLeft,
                            behavior: 'smooth'
                        });
                    });
                });
            }

            const dots = dotsContainer ? dotsContainer.children : [];

            const updateActiveItem = () => {
                if (panel.classList.contains('hidden')) return;
                const trackCenter = track.scrollLeft + track.clientWidth / 2;
                let closestIndex = 0;
                let minDistance = Infinity;
                const maxDist = track.clientWidth * 0.55;

                items.forEach((item, index) => {
                    const itemCenter = item.offsetLeft + item.clientWidth / 2;
                    const distance = Math.abs(trackCenter - itemCenter);
                    
                    let progress = 1 - (distance / maxDist);
                    if (progress < 0) progress = 0;
                    
                    const easedProgress = Math.pow(progress, 1.4);
                    const scale = 0.85 + (easedProgress * 0.15);
                    
                    gsap.set(item, {
                        opacity: easedProgress,
                        scale: scale
                    });
                    
                    if (distance < minDistance) {
                        minDistance = distance;
                        closestIndex = index;
                    }
                });

                if (dots.length > 0) {
                    Array.from(dots).forEach((dot, index) => {
                        if (index === closestIndex) {
                            dot.classList.replace('bg-white/20', 'bg-white');
                        } else {
                            dot.classList.replace('bg-white', 'bg-white/20');
                        }
                    });
                }
            };

            track.addEventListener('scroll', () => {
                window.requestAnimationFrame(updateActiveItem);
            });

            if (nextBtn) {
                nextBtn.addEventListener('click', (e) => {
                    e.preventDefault();
                    const itemWidth = items[0].clientWidth;
                    track.scrollBy({ left: itemWidth, behavior: 'smooth' });
                });
            }
            if (prevBtn) {
                prevBtn.addEventListener('click', (e) => {
                    e.preventDefault();
                    const itemWidth = items[0].clientWidth;
                    track.scrollBy({ left: -itemWidth, behavior: 'smooth' });
                });
            }

            return { update: updateActiveItem, track: track };
        }

        // Initialize carousels for all mood tabs
        const carousels = [];
        tabContents.forEach(panel => {
            const c = setupCarousel(panel);
            if (c) carousels.push({ id: panel.id, ...c });
        });

        // Run initial setup for the visible tab
        setTimeout(() => {
            if (carousels.length > 0 && carousels[0].update) {
                carousels[0].update();
                carousels[0].track.scrollTo({ left: 0, behavior: 'auto' });
            }
        }, 120);

        // Tab Switching Click Handler (The Memory Atlas vs The Everyday Edit)
        if (tabBtns.length > 0) {
            tabBtns.forEach(btn => {
                btn.addEventListener('click', (e) => {
                    e.preventDefault();
                    const targetId = btn.getAttribute('data-target');
                    if (!targetId) return;

                    // Update Tab Button States
                    tabBtns.forEach(b => {
                        b.classList.remove('active', 'bg-white', 'text-black', 'border-white', 'shadow-[0_0_25px_rgba(255,255,255,0.2)]');
                        b.classList.add('bg-white/5', 'text-gray-400', 'border-white/15');
                        b.setAttribute('aria-selected', 'false');
                    });
                    btn.classList.add('active', 'bg-white', 'text-black', 'border-white', 'shadow-[0_0_25px_rgba(255,255,255,0.2)]');
                    btn.classList.remove('bg-white/5', 'text-gray-400', 'border-white/15');
                    btn.setAttribute('aria-selected', 'true');

                    // Switch Tab Panels
                    tabContents.forEach(panel => {
                        if (panel.id === targetId) {
                            panel.classList.remove('hidden');
                            gsap.fromTo(panel, 
                                { opacity: 0, y: 15 }, 
                                { opacity: 1, y: 0, duration: 0.45, ease: 'power2.out' }
                            );
                            
                            // Re-calculate active carousel for newly visible tab
                            const activeC = carousels.find(c => c.id === targetId);
                            if (activeC) {
                                setTimeout(() => {
                                    activeC.update();
                                    activeC.track.scrollTo({ left: 0, behavior: 'smooth' });
                                }, 60);
                            }
                        } else {
                            panel.classList.add('hidden');
                        }
                    });
                });
            });
        }

        // Quick Add to Cart button handler (Choose your mood direct homepage access)
        document.addEventListener('click', (e) => {
            const quickBtn = e.target.closest('.quick-add-btn');
            if (quickBtn) {
                e.preventDefault();
                e.stopPropagation();
                const variantId = quickBtn.getAttribute('data-variant-id');
                const productUrl = quickBtn.getAttribute('data-product-url');
                
                if (variantId && variantId !== '' && variantId !== 'null' && variantId !== 'undefined') {
                    const originalHtml = quickBtn.innerHTML;
                    quickBtn.innerHTML = '<svg class="w-3.5 h-3.5 animate-spin" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path></svg>';
                    quickBtn.disabled = true;

                    fetch('/cart/add.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
                    })
                    .then(res => {
                        if (!res.ok) throw new Error('Add to cart failed');
                        return res.json();
                    })
                    .then(() => {
                        quickBtn.innerHTML = originalHtml;
                        quickBtn.disabled = false;
                        if (typeof updateCartDrawer === 'function') updateCartDrawer();
                        if (typeof openCartDrawer === 'function') openCartDrawer();
                    })
                    .catch(() => {
                        quickBtn.innerHTML = originalHtml;
                        quickBtn.disabled = false;
                        if (productUrl && productUrl !== '#' && productUrl !== '') {
                            window.location.href = productUrl;
                        }
                    });
                } else if (productUrl && productUrl !== '#' && productUrl !== '') {
                    window.location.href = productUrl;
                }
            }
        });
        
        // 6. Product Details Page (PDP) Animations
        const productImage = document.querySelector('.gsap-product-image');
        if (productImage) {
            gsap.to(productImage, {
                opacity: 1,
                y: 0,
                duration: 1.5,
                ease: "power3.out",
                delay: 0.2
            });
        }
        
        // Thumbnail swapping logic
        const thumbnails = document.querySelectorAll('.thumbnail-btn');
        const mainImage = document.getElementById('main-product-image');
        
        if (thumbnails.length > 0 && mainImage) {
            thumbnails.forEach(btn => {
                btn.addEventListener('click', () => {
                    // Update active state
                    thumbnails.forEach(t => {
                        t.classList.remove('active', 'border-white/50');
                        t.classList.remove('opacity-100');
                        t.classList.add('opacity-60');
                    });
                    btn.classList.add('active', 'border-white/50', 'opacity-100');
                    btn.classList.remove('opacity-60');
                    
                    // Crossfade animation
                    const newSrc = btn.getAttribute('data-image-src');
                    gsap.to(mainImage, {
                        opacity: 0,
                        duration: 0.3,
                        onComplete: () => {
                            mainImage.src = newSrc;
                            // Reset srcset if it's an image tag generated by shopify
                            mainImage.removeAttribute('srcset');
                            gsap.to(mainImage, { opacity: 1, duration: 0.5, ease: "power2.out" });
                        }
                    });
                });
            });
        }
        
          // Discover Signature Stagger Animation
        const discoverSections = document.querySelectorAll('.gsap-discover-section');
        discoverSections.forEach(section => {
            const container = section.querySelector('.gsap-discover-container');
            if (!container) return;
            
            const buttons = container.querySelector('.gsap-discover-buttons');
            const image = container.querySelector('.gsap-discover-image');
            
            // Image Scrub
            if (image) {
                // Set initial state
                gsap.set(image, { "--reveal-stop": "-10%", opacity: 0, x: -20 });
                
                const tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: section,
                        start: "top top", // Starts animating when the section hits top of screen
                        end: "bottom bottom", // Finishes when the bottom of the section hits bottom of screen
                        scrub: 1
                    }
                });
                
                // Animate image reveal with a soft wipe from left to right
                tl.to(image, {
                    "--reveal-stop": "100%",
                    x: 0,
                    opacity: 1,
                    duration: 2, // Takes up more of the scroll distance to slow it down
                    ease: "none" // Removes the slow-start 'delay' by making the scrub perfectly linear
                });
                
                if(buttons) {
                    tl.from(buttons, {
                        opacity: 0,
                        y: 30,
                        duration: 0.5,
                        ease: "power2.out"
                    });
                }
                
                tl.to(image, { duration: 1.5 }); // Huge hold at the end to keep the section fully visible for 1.5 screens before moving on
            }
        });
        
        // ==========================================
        // AJAX CART DRAWER LOGIC
        // ==========================================
        const cartDrawer = document.getElementById('adamea-cart-drawer');
        const cartPanel = document.getElementById('cart-drawer-panel');
        const cartBackdrop = document.getElementById('cart-drawer-backdrop');
        const cartCloseBtn = document.getElementById('cart-drawer-close');
        const cartContinueBtn = document.getElementById('cart-drawer-continue');
        const cartIcons = document.querySelectorAll('a[href="/cart"]');
        const addToCartForm = document.getElementById('product-form');

        const openCartDrawer = () => {
            if (cartDrawer) {
                cartDrawer.classList.remove('pointer-events-none');
                cartBackdrop.classList.remove('opacity-0');
                cartBackdrop.classList.add('opacity-100', 'pointer-events-auto');
                cartPanel.classList.remove('translate-x-full');
            }
        };

        const closeCartDrawer = () => {
            if (cartDrawer) {
                cartBackdrop.classList.remove('opacity-100', 'pointer-events-auto');
                cartBackdrop.classList.add('opacity-0');
                cartPanel.classList.add('translate-x-full');
                setTimeout(() => {
                    cartDrawer.classList.add('pointer-events-none');
                }, 500);
            }
        };

        if (cartCloseBtn) cartCloseBtn.addEventListener('click', closeCartDrawer);
        if (cartBackdrop) cartBackdrop.addEventListener('click', closeCartDrawer);
        
        // Prevent default cart page navigation on all cart icons
        if (cartIcons.length > 0) {
            cartIcons.forEach(icon => {
                icon.addEventListener('click', (e) => {
                    e.preventDefault();
                    updateCartDrawer();
                    openCartDrawer();
                });
            });
        }

        // Delegate events for dynamically loaded content
        if (cartDrawer) {
            cartDrawer.addEventListener('click', (e) => {
                if (e.target.closest('#cart-drawer-continue')) {
                    closeCartDrawer();
                }
                
                const qtyBtn = e.target.closest('.cart-qty-btn');
                if (qtyBtn) {
                    const line = qtyBtn.getAttribute('data-line');
                    const qty = qtyBtn.getAttribute('data-qty');
                    changeCartQuantity(line, qty);
                }
            });
        }

        // Add to Cart Intercept
        if (addToCartForm) {
            addToCartForm.addEventListener('submit', (e) => {
                e.preventDefault();
                
                // Submit via fetch
                const formData = new FormData(addToCartForm);
                fetch('/cart/add.js', {
                    method: 'POST',
                    body: formData
                })
                .then(response => response.json())
                .then(data => {
                    updateCartDrawer();
                    openCartDrawer();
                })
                .catch((error) => {
                    console.error('Error adding to cart:', error);
                });
            });
        }

        const updateCartDrawer = () => {
            // Fetch the cart-drawer section rendering API
            fetch('/?section_id=cart-drawer')
                .then(response => response.text())
                .then(html => {
                    const temp = document.createElement('div');
                    temp.innerHTML = html;
                    
                    const newContents = temp.querySelector('#cart-drawer-contents');
                    const newFooter = temp.querySelector('.border-t.border-white\\/10'); // Footer
                    
                    const oldContents = document.getElementById('cart-drawer-contents');
                    const oldFooterWrapper = cartPanel; // We'll replace the footer inside the panel
                    
                    if (oldContents && newContents) {
                        oldContents.innerHTML = newContents.innerHTML;
                    }
                    
                    // Re-inject footer
                    const existingFooter = oldFooterWrapper.querySelector('.border-t.border-white\\/10');
                    if (existingFooter) existingFooter.remove();
                    if (newFooter) {
                        oldFooterWrapper.appendChild(newFooter);
                    }
                })
                .catch(error => console.error('Error updating cart drawer:', error));
        };

        const changeCartQuantity = (line, qty) => {
            fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    line: line,
                    quantity: qty
                })
            })
            .then(response => response.json())
            .then(data => {
                updateCartDrawer();
            })
            .catch((error) => {
                console.error('Error changing cart quantity:', error);
            });
        };
        
        // 7. General Text Fades
        const textFades = document.querySelectorAll('.gsap-text-fade');
        textFades.forEach(el => {
            gsap.from(el, {
                scrollTrigger: {
                    trigger: el,
                    start: "top 85%"
                },
                opacity: 0,
                y: 20,
                duration: 1,
                ease: "power2.out"
            });
        });

        // 8. Letter by Letter Reveal
        const letterReveals = document.querySelectorAll('.gsap-letter-reveal');
        letterReveals.forEach(el => {
            // Only split text nodes, preserve HTML structure if any
            if (el.children.length === 0) {
                const text = el.innerText;
                el.innerHTML = '';
                // Split text into words, then words into letters, to preserve wrapping gracefully
                const words = text.split(' ');
                words.forEach((word, wordIndex) => {
                    const wordSpan = document.createElement('span');
                    wordSpan.className = "inline-block whitespace-nowrap";
                    
                    word.split('').forEach(char => {
                        const charSpan = document.createElement('span');
                        charSpan.innerText = char;
                        charSpan.className = "inline-block opacity-0 translate-y-4";
                        wordSpan.appendChild(charSpan);
                    });
                    
                    el.appendChild(wordSpan);
                    
                    if (wordIndex < words.length - 1) {
                        const spaceSpan = document.createElement('span');
                        spaceSpan.innerHTML = '&nbsp;';
                        spaceSpan.className = "inline-block";
                        el.appendChild(spaceSpan);
                    }
                });
                
                // Animate the characters
                const chars = el.querySelectorAll('span > span.opacity-0');
                gsap.to(chars, {
                    scrollTrigger: {
                        trigger: el,
                        start: "top 85%"
                    },
                    opacity: 1,
                    y: 0,
                    duration: 0.6,
                    stagger: 0.015,
                    ease: "power2.out"
                });
            }
        });
        
        // ==========================================
        // SEARCH DRAWER LOGIC
        // ==========================================
        const searchDrawer = document.getElementById('adamea-search-drawer');
        const searchPanel = document.getElementById('search-drawer-panel');
        const searchBackdrop = document.getElementById('search-drawer-backdrop');
        const searchCloseBtn = document.getElementById('search-drawer-close');
        const searchIcons = document.querySelectorAll('a[href="/search"]');
        const searchInput = document.getElementById('SearchInput');
        const searchResultsContainer = document.getElementById('predictive-search-results');
        
        let searchTimeout = null;

        const openSearchDrawer = () => {
            if (searchDrawer) {
                searchDrawer.classList.remove('pointer-events-none');
                searchBackdrop.classList.remove('opacity-0');
                searchBackdrop.classList.add('opacity-100', 'pointer-events-auto');
                searchPanel.classList.remove('-translate-y-full');
                setTimeout(() => {
                    if (searchInput) searchInput.focus();
                }, 300);
            }
        };

        const closeSearchDrawer = () => {
            if (searchDrawer) {
                searchBackdrop.classList.remove('opacity-100', 'pointer-events-auto');
                searchBackdrop.classList.add('opacity-0');
                searchPanel.classList.add('-translate-y-full');
                setTimeout(() => {
                    searchDrawer.classList.add('pointer-events-none');
                }, 500);
            }
        };

        if (searchCloseBtn) searchCloseBtn.addEventListener('click', closeSearchDrawer);
        if (searchBackdrop) searchBackdrop.addEventListener('click', closeSearchDrawer);
        
        if (searchIcons.length > 0) {
            searchIcons.forEach(icon => {
                icon.addEventListener('click', (e) => {
                    e.preventDefault();
                    openSearchDrawer();
                });
            });
        }
        
        // Predictive Search API Call
        if (searchInput && searchResultsContainer) {
            const defaultHTML = searchResultsContainer.innerHTML; // Store best sellers
            
            searchInput.addEventListener('input', (e) => {
                const query = e.target.value.trim();
                
                clearTimeout(searchTimeout);
                
                if (query.length === 0) {
                    searchResultsContainer.innerHTML = defaultHTML;
                    return;
                }
                
                searchTimeout = setTimeout(() => {
                    // Call Shopify Predictive Search API
                    fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=4`)
                        .then(response => response.json())
                        .then(data => {
                            const products = data.resources.results.products;
                            if (products && products.length > 0) {
                                let html = `<div class="col-span-full mb-2"><h3 class="text-[9px] md:text-[10px] uppercase tracking-[0.3em] text-gray-500">Search Results</h3></div>`;
                                products.forEach(product => {
                                    html += `
                                        <a href="${product.url}" class="group flex flex-col p-4 md:p-6 rounded-2xl bg-white/[0.03] backdrop-blur-xl border border-white/10 hover:bg-white/[0.08] hover:border-white/20 transition-all duration-300">
                                            <div class="w-full aspect-[4/5] rounded-xl overflow-hidden mb-4 md:mb-6 bg-black/30 flex items-center justify-center p-3 md:p-4">
                                                <img src="${product.image || 'bottle.png'}" class="w-full h-full object-contain transition-transform duration-700 group-hover:scale-110 drop-shadow-2xl mix-blend-screen" alt="${product.title}">
                                            </div>
                                            <h4 class="font-serif text-sm md:text-base tracking-widest uppercase group-hover:text-gray-300 transition-colors">${product.title}</h4>
                                            <span class="text-[9px] md:text-[10px] uppercase tracking-[0.2em] text-gray-500 mt-2">${product.price}</span>
                                        </a>
                                    `;
                                });
                                searchResultsContainer.innerHTML = html;
                            } else {
                                searchResultsContainer.innerHTML = `<div class="col-span-full py-12 text-center"><p class="text-gray-400 font-serif text-2xl tracking-widest uppercase">No products found</p></div>`;
                            }
                        })
                        .catch(err => {
                            console.error('Error fetching predictive search:', err);
                        });
                }, 300); // 300ms debounce
            });
        }

        // Recalculate all ScrollTriggers to account for pinning layout shifts
        ScrollTrigger.sort();
        ScrollTrigger.refresh();
    }
});
